const config = {
    KAMap: {
        'Bra Calculator': 'Bra Calculator',
        'Size Chart': 'Size Chart',
        'Fit Guide': 'Fit Guide',
        'Buying Guide': 'Buying Guide',
        'Shoe Guide': 'Shoe Guide',
        'Ring Sizer': 'Ring Sizer',
        'Watch Case Size Guide': 'Watch Size Guide',
        'Jewelry Guide': 'Jewelry Guide',
    },

    placement: {
        TOP_PLACEMENT: 'top',
        BOTTOM_PLACEMENT: 'bottom',
    },
};

export default config;
